'use client';

import { useEffect, useState } from 'react';

export const useIsTouchDevice = () => {
  const [isTouchDevice, setIsTouchDevice] = useState(false);

  useEffect(() => {
    const check = () => 'ontouchstart' in window || navigator.maxTouchPoints > 0;

    setIsTouchDevice(check());

    const mediaQuery = window.matchMedia('(hover: none)');
    const handleChange = () => {
      setIsTouchDevice(check());
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return isTouchDevice;
};
